module.exports = __webpack_public_path__ + "static/media/features-tabs-image.8046c92d.png";